
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/ember_iframe/templates/template"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<iframe\n  frameborder='0'\n  src='"
    + alias4(((helper = (helper = lookupProperty(helpers,"url") || (depth0 != null ? lookupProperty(depth0,"url") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"url","hash":{},"data":data,"loc":{"start":{"line":3,"column":7},"end":{"line":3,"column":14}}}) : helper)))
    + "'\n  title='Insights: "
    + alias4(((helper = (helper = lookupProperty(helpers,"workspace_name") || (depth0 != null ? lookupProperty(depth0,"workspace_name") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"workspace_name","hash":{},"data":data,"loc":{"start":{"line":4,"column":19},"end":{"line":4,"column":37}}}) : helper)))
    + "'></iframe>\n\n<div\n  class='progress-bar'\n  id='ember-progress-bar'></div>\n";
},"useData":true});
    }).call(this);
  